// Default rate limit rules — shared between API (middleware) and DB seed.
// These match the hardcoded auth limiters that existed before dynamic config.
export const DEFAULT_RATELIMIT_RULES = [
  { path: '/api/auth/login', methods: ['POST'], points: 5, durationSec: 900, keyBy: 'user' },
  { path: '/api/auth/register', methods: ['POST'], points: 3, durationSec: 3600 },
  { path: '/api/auth/recover/*', methods: ['POST'], points: 5, durationSec: 900 },
  { path: '/api/mobile/auth/login', methods: ['POST'], points: 5, durationSec: 900, keyBy: 'user' },
  { path: '/api/mobile/auth/refresh', methods: ['POST'], points: 30, durationSec: 60 },
  { path: '/api/admin/auth/login', methods: ['POST'], points: 5, durationSec: 900 },
  { path: '/api/platform/auth/login', methods: ['POST'], points: 5, durationSec: 900 },
  { path: '/api/web/checkout/*', methods: ['POST'], points: 10, durationSec: 3600 },
] as const;

export const DEFAULT_RATELIMIT_RULES_JSON = JSON.stringify(DEFAULT_RATELIMIT_RULES);
